export default "__VITE_ASSET__CGV0akQM__"